import _classCallCheck from "/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /*#__PURE__*/function (_Error) {
  _inherits(SentryError, _Error);
  var _super = _createSuper(SentryError);
  /** Display name of this error instance. */

  function SentryError(message) {
    var _this;
    _classCallCheck(this, SentryError);
    _this = _super.call(this, message);
    _this.message = message;
    ;
    _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name;
    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof SentryError ? this.constructor : void 0).prototype);
    return _this;
  }
  return SentryError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { SentryError };